// extracted by mini-css-extract-plugin
export default {"external":"aP2EOl","wrapper":"bP2EOl","block":"cP2EOl","link":"dP2EOl","assetsLinksBlock":"eP2EOl","image":"fP2EOl","title":"gP2EOl"};